export const sortTypes = {
  bookings: 'bookings',
  lifetime_value: 'lifetime_value',
  last_book_date: 'last_book_date',
  name: '_id.name',
  email: '_id.email',
  createdAt: '_id.createdAt',
  last_login: '_id.last_login',
}

const defaultSortingState = {
  [sortTypes.bookings]: undefined,
  [sortTypes.name]: undefined,
  [sortTypes.lifetime_value]: undefined,
  [sortTypes.createdAt]: undefined,
  [sortTypes.last_book_date]: undefined,
  [sortTypes.last_login]: undefined,
}
export const customersState = {
  customers: [],
  sorting: defaultSortingState,
  loading: false,
  error: undefined,
  total_pages: 1,
  total_customers: 0,
  searchOptions: {
    variable: undefined
  },
  paginationOptions: {
    per_page: 100,
    page: 1,
  }
};

export default function CustomersReducer(state = customersState, action) {
  switch (action.type) {
    case customersActions.setCustomers:
      return {
        ...state,
        ...action.data,
        loading: false
      }

    case customersActions.setSorting:
      return {
        ...state,
        sorting: {
          ...action.data
        }
      }

    case customersActions.loading_customers:
      return {
        ...state,
        loading: action.data,
      }

    case customersActions.setPage:
      return {
        ...state,
        // reset sorting,
        sorting: defaultSortingState,
        paginationOptions: {
          ...state.paginationOptions,
          page: action.data,
        }
      }
    
    case customersActions.setPerPage:
      return {
        ...state,
        paginationOptions: {
          ...state.paginationOptions,
          per_page: action.data,
        }
      }

    case customersActions.setVariable:
      return {
        ...state,
        searchOptions: {
          ...state.searchOptions,
          variable: action.data,
        }
      }

    case customersActions.setError:
      return {
        ...state,
        loading: false,
        error: typeof action.data === 'string'? action.data : JSON.stringify(action.data)
      }
      
    default: return state;
  }
}

/** ActionTypes */
export const customersActions = {
  setCustomers: "customers/SET_CUSTOMERS",
  loading_customers: "customers/LOADING",

  setSorting: 'customers/SET_SORTING',

  setPerPage: 'customers/SET_PER_PAGE',
  setPage: 'customers/SET_PAGE',
  setVariable: 'customers/SET_VARIABLE',

  setError: 'customers/ERROR',
}